import dispatcher from '../others/Dispatcher';

export function updateTickets(tickets) {
    dispatcher.dispatch({
        type: 'UPDATE_QUICKWIN_TICKETS',
        body: tickets
    });
}

export function updateAdvancedTickets(tickets) {
    dispatcher.dispatch({
        type: 'UPDATE_QUICKWIN_TICKETS_ADVANCED_DISPLAY',
        body: tickets
    })
}

export function updateFilter(filter) {
    dispatcher.dispatch({
        type: 'UPDATE_QUICKWIN_FILTER',
        body: filter
    });
}

export function updateSort(sort) {
    dispatcher.dispatch({
        type: 'UPDATE_QUICKWIN_SORT',
        body: sort
    });
}

export function updateMeta(meta) {
    dispatcher.dispatch({
        type: 'UPDATE_QUICKWIN_META',
        body: meta
    });
}

export function updateState(state) {
    dispatcher.dispatch({
        type: 'UPDATE_QUICKWIN_STATE',
        body: state
    })
}





// WEBPACK FOOTER //
// ./src/js/actions/QuickWinActions.js